module['exports'] = [
  'آستن مارٹن',
  'بینٹلے',
  'بی ایم ڈبلیو',
  'فراری',
  'ہنڈا',
  'جیپ',
  'مزدا',
  'مرسیڈیز',
];
